module.exports = __webpack_public_path__ + "img/GR123.be2216ef.svg";